import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { OrderReceiveReceiptBlockConfig } from '@front-platform/content-builder';
import { orderReceiveReceiptBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';
import {
  ReceiveReceiptModalComponent,
  ReceiveReceiptModalReceiptType,
} from '@shared/modals/receive-receipt-modal/receive-receipt-modal.component';
import { ModalsService } from '@core/services/modals/modals.service';
import { OrderStoreSelector } from '@common/selectors/order.selector';
export interface OrderReceiveReceiptBlockRuntimeConfig {}

export type OrderReceiveReceiptBlockConfigInput = Partial<
  Omit<OrderReceiveReceiptBlockConfig, keyof OrderReceiveReceiptBlockRuntimeConfig> &
    OrderReceiveReceiptBlockRuntimeConfig
>;
export type OrderReceiveReceiptBlockResolvedConfig = Omit<
  OrderReceiveReceiptBlockConfig,
  keyof OrderReceiveReceiptBlockRuntimeConfig
> &
  Partial<OrderReceiveReceiptBlockRuntimeConfig>;
export interface OrderReceiveReceiptBlockContract extends ConfigComponentContract<
  OrderReceiveReceiptBlockConfigInput,
  OrderReceiveReceiptBlockResolvedConfig
> {}

@Component({
  selector: 'app-order-receive-receipt-block',
  templateUrl: './order-receive-receipt-block.component.html',
  styles: [],
  standalone: false,
})
export class OrderReceiveReceiptBlockComponent implements OrderReceiveReceiptBlockContract {
  readonly config = input<OrderReceiveReceiptBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    OrderReceiveReceiptBlockConfig,
    OrderReceiveReceiptBlockRuntimeConfig
  >(orderReceiveReceiptBlockResolveConfig, () => ({ config: this.config() }));

  /** Kept for template `@if (display)` — defaults to true when not configured. */
  get display(): boolean {
    return (this.resolvedConfig()['display'] as unknown as boolean | undefined) ?? true;
  }

  constructor(
    private readonly modalsService: ModalsService,
    private readonly orderSelector: OrderStoreSelector,
  ) {}

  openModalReceipt(): void {
    const order = this.orderSelector.active;
    const payment = order?.payments?.[0];
    if (!payment) {
      return;
    }

    this.modalsService.open(ReceiveReceiptModalComponent.handle, undefined, {
      receiptType: ReceiveReceiptModalReceiptType.payment,
      receiptId: payment.id,
    });
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(OrderReceiveReceiptBlockComponent, {
  'keyAliases': {},
});
